<template>
    <div>
        <section id="top" class="container justify-content-center">
            <div class="row">
                <div class="col">
                    <h1 class="section--title section--title__large">{{ $t("companyname") }}</h1>
                    <hr>
                </div>
            </div>
            <div class="vertical-line-container">
                <div class="vertical-line"></div>
            </div> 
        </section>

        <section id="hero">
            <div class="top-ellipse"></div>
            <div class="container">
                <div class="col">
                    <div class="row hero--header__large">
                        {{ $t("webacknonconformists") }}
                    </div>
                    <div class="row hero--header__large">
                        {{ $t("weembraceentropy") }}
                    </div>
                    <div class="row hero--text__normal">
                        {{ $t("people>policy") }}
                    </div>
                    <div class="row hero--text__normal">
                        {{ $t("passion>procedures") }}
                    </div>
                    <div class="row hero--text__normal">
                        {{ $t("prototypes>powerpoints") }}
                    </div>
                </div>
            </div>
            <div class="vertical-line-container">
                <div class="vertical-line"></div>
            </div> 
        </section>

        <section id="portfolio">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <h1 class="section--title">{{ $t("portfolio") }}</h1>
                        <hr>
                    </div>
                </div>
                <div class="gridCard">
                    <div id="portfolioCardClassic">
                        <a href="https://www.adyen.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/adyen_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
<!--                    <div id="portfolioCardClassic">
                        <a href="https://www.aidetect.co.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/aidetect2.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
-->
                    <div id="portfolioCardClassic">
                        <a href="https://www.almata.co.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/almata_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://aquila.company/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/aquila.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://assethub.io/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/asset_hub.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.authenticindication.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/authentic-logo.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://axive-ai.co.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/axive.png" class="card-image">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.azarus.io/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/azarus_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.brj.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/brj_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="http://www.braid.tech/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/braid.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.colega.ai/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/colegaAI.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.contrea.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/contrea_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.daantech.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/daan_tech.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://entouch.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/entouch_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.ezcater.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/gocater_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.gu-tech.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/gutech.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://guiderobotics.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/guiderobotics.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <div class="card">
                            <img src="img/portfolio/hodl.png" class="card-image">
                            <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                        </div>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://idear.world" target="blank">
                            <div class="card">
                                <img src="img/portfolio/idear_logo.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
<!--                        <a href="https://" target="blank">      -->
                            <div class="card">
                                <img src="img/portfolio/implicit.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://lecto.co.jp" target="blank">
                            <div class="card">
                                <img src="img/portfolio/lecto_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://shizen.vc" target="blank"> 
                            <div class="card">
                                <img src="img/portfolio/legolas_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.luca.inc" target="blank">
                            <div class="card">
                                <img src="img/portfolio/luca.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.makeleaps.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/makeleaps_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
<!--                        <a href="https://mujin.life" target="blank">     -->
                            <div class="card">
                                <img src="img/portfolio/mujin.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.nozomimed.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/nozomi_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://nyuuly.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/nyuuly.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;" >
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.ocean.inc/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/ocean.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.okke.co.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/okke_logo_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://optfit.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/optfit_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://shizen.vc/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/orca.png" class="card-image">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://pinion.jp/" target="blank"> 
                            <div class="card">
                                <img src="img/portfolio/pinionx.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.pi-xcels.com/" target="blank"> 
                            <div class="card">
                                <img src="img/portfolio/pi-xcels.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://queri.co.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/queri_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://rakunage.co.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/raQkan_bw.png" class="card-image">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.reboot-japan.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/reboot_bw.png" class="card-image">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.reiwaseiyaku.co.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/reiwa_bw.png" class="card-image">
                            </div>
                        </a>
                    </div>

<!--                    
                    <div id="portfolioCardClassic">
                        <a href="https://www.rongolive.com/" target="blank">   
                            <div class="card">
                                <img src="img/portfolio/rongo.png" class="card-image">
                            </div>
                        </a>
                    </div>
-->
                    <div id="portfolioCardClassic">
                        <a href="https://www.fusionsystems.group/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/seya_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://shisa.ai/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/shisa_logo.png" class="card-image">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://signtime.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/signtime.png" class="card-image">
                            </div>
                        </a>
                    </div>
<!--                    <div id="portfolioCardClassic">
                        <a href="https://smartpay.co/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/smartpay.svg" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
-->
                    <div id="portfolioCardClassic">
                        <a href="https://syd.life/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/syd_life.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://totemo.art/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/totemo.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.triptojapan.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/ttj.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://turngroup.co.jp/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/turngroup.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://viila.co/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/viila_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.vouchconcierge.com/en/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/vouch.jpg" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <div class="card">
                            <img src="img/portfolio/wagmi.png" class="card-image">
                            <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                        </div>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.wamazing.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/wamazing.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://woodstock.co" target="blank">
                            <div class="card">
                                <img src="img/portfolio/woodstock2.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://xdeli.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/xDeli.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://www.xmap.ai/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/xmap.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://yuichi.io/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/yuichi.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://zeteoh.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/zeteoh_bw.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                    <div id="portfolioCardClassic">
                        <a href="https://zookeep.com/" target="blank">
                            <div class="card">
                                <img src="img/portfolio/zookeep.png" class="card-image">
                                <img src="img/portfolio/exited.png" class="exited" style="display: none;">
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="vertical-line-container">
                <div class="vertical-line"></div>
            </div> 
        </section>

        <section id="people">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3 section--title">{{ $t("people") }}</h2>
                    </div>
                </div>
                 <h3 class="subsection--title">Operating Team</h3>
                <div class="row">
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/matthew_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("matthewromaine") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/quanza" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/mromaine/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/mayumi_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("mayumimaruyoshi") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/mayumi-maruyoshi-032b38177/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/mb_jpj_un_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("markbivens") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/markbivens" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/markbivens/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                 
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/sophie_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("sophiemeralli") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://x.com/Soph_VC" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/sophie-meralli/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>  
-->
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/wakebe_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("mayumiwakebe") }}</span> 
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/mayumi-wakebe-7694a623/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/shizen-chan_bw.jpeg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("shizenchan") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://linkedin.com/company/shizen" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/naoki_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("naokihirukawa") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/naoki-hirukawa/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    -->
                </div>
                <h3 class="subsection--title">Venture Partners</h3>
                <div class="row">
<!--                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/mai-iida_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("maiiida") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/xvcmaiiida" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/maiiida/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>  -->
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/iguchi.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("nobuiguchi") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/nobu-iguchi/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
<!--
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/emiko.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("emikotakeda") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/emiko-takeda-518317209/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
-->
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/marktan.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("marktan") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/mark-tan-2902a12b/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/adrien_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("adrienjelic") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/adrien-jelic-5a0a0914/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/stephane_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("stephanebittoun") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/st%C3%A9phane-bittoun-9841334a/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/loic.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("loicrethore") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/shizencapital" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/loicrethore/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>    
                    <div class="col-md-6 col-lg-4 mb-5 mb-lg-0 profile-container">
                        <div class="px-4">
                            <img v-lazy="'img/team-photos/jay_winder_bw.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover profile-photo">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1 text-primary">{{ $t("jaywinder") }}</span>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/itsjaydesu" type="primary" icon="fab fa-twitter" rounded icon-only></base-button>
                                    <base-button tag="a" href="https://www.linkedin.com/in/jaywinder/" type="primary" icon="fab fa-linkedin" rounded icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
            <div class="vertical-line-container">
                <div class="vertical-line"></div>
            </div> 
        </section>

        <section id="perspectives" class="section-shaped my-0 pb-100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 section--title">{{ $t("perspectives") }}</h2>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-12">
                        <carousel autoplayDirection="backward"
                            :scrollPerPage="true" 
                            :autoplay="true" 
                            :perPageCustom="[[480, 2], [768, 3]]"
                            :navigationEnabled="true"
                        >
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/HowToPitchUs">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/shizen_pitch_bw.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>How to pitch us</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/HowToPitchUsJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/shizen_pitch_bw.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>自然キャピタルにどうピッチするべきか</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/VCMath">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/vc_math.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>VC Math</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/VCMathJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/vc_math.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>VC Math</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>

                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/VCRadar2023">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/vc-radar-2023_thumb.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Japan VC Radar 2023</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/VCRadar2023JP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/vc-radar-2023_thumb.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>日本VCレーダー 2023</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/SweetSpot">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/shizen_stones_bw.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Our investment sweet spot</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/SweetSpotJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/shizen_stones_bw.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Our investment sweet spot</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/FranceInnovationRenaissance">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/french-innovation-renaissance_bw.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>What Japan can learn from the French Innovation Renaissance</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/FranceInnovationRenaissanceJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/french-innovation-renaissance_bw.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>日本がフランスのイノベーション・ルネッサンスから学べること</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/Sprout">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/shizen-sprout.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>A new opportunity for future female VC leaders in Japan</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/SproutJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/shizen-sprout.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>日本の女性VCリーダーに新たなチャンスを</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>

                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/JapanMA">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/japan-startup-m&a.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Startup M&A in Japan: Fasten your seatbelts</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/JapanMAJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/japan-startup-m&a.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>日本でこれからスタートアップのM＆Aイグジットが増える理由</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/DueDiligenceTrap">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/eternal-due-diligence.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>The trap of superfluous “due diligence”</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/DueDiligenceTrapJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/eternal-due-diligence.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>余計な〝デューデリジェンス〟の罠</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/LeadVC">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/break-from-the-sheep.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>On the importance of a Lead VC</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/LeadVCJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/break-from-the-sheep.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>リードVCの重要性</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>

                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/privateequityjapan">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/privateequityjapan_bw2.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>A Perfect storm for private equity in Japan ?</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/privateequityjapanJP">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/privateequityjapan_bw2.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>日本におけるプライベート・エクイティ：最悪の事態？</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/turbulence">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/turbulence_bw2.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>How Startups can Prepare for Market Turbulence</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/turbulencejp">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/turbulence_bw2.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>スタートアップはどのように市場の乱高下に備えるべきか</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/bloggingasarecruitingtool">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/bloggingrecruiting_bw.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Blogging as a Recruiting Tool</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/bloggingasarecruitingtooljp">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/bloggingrecruiting_bw.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>求人ツールとしてのブログ</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/whyaumisthewrongmetricinvc">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/aumwrongmetric_bw.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Why AUM is the Wrong Metric in VC</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/whyaumisthewrongmetricinvcjp">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/aumwrongmetric_bw.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>AUMがVCの間違った指標である理由</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/whyitendtopreferequityroundsovernotes">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/equityrounds2.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Why I Tend to Prefer Equity Rounds Over Notes</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/whyitendtopreferequityroundsovernotesjp">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/equityrounds2.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>ノートよりもエクイティラウンドを好む傾向がある理由</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/clubhouseinjapan">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/clubhouse-japan.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Clubhouse In Japan</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'">
                                <div class="card">
                                    <router-link to="/perspectives/futureofremotework">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/forw.png"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Future of Remote Work</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'en'">
                                <div class="card">
                                    <router-link to="/perspectives/sugokurare">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/rare.png"/>
                                        </div>  
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>Sugoku rare: NFTs in Japan</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'" style="width: 300px; max-width: 100%;">
                                <div class="card">
                                    <router-link to="/perspectives/clubhouseinjapanjp">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/clubhouse-japan.jpg"/>
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>{{ $t("clubhouseinjapan") }}</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'">
                                <div class="card">
                                    <router-link to="/perspectives/cannotcoachheightjp">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/cannotcoachheight.png" alt="image description" />
                                        </div>
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>{{ $t("cannotcoachheight") }}</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                            <slide v-if="this.$i18n.locale === 'jp'">
                                <div class="card">
                                    <router-link to="/perspectives/2021techtrendsjp">
                                        <div class="card__image">
                                            <img class="perspective__image" src="img/blog/card/2021techtrends.png"/>
                                        </div>  
                                        <div class="card__content">
                                            <div class="card__title">
                                                <span>{{ $t("2021techtrends") }}</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </slide>
                        </carousel>
                    </div>
                </div>
            </div>
            <div class="bottom-ellipse"></div>
        </section>
    </div>
</template>

<script>
    import { Carousel, Slide } from "vue-carousel";
    import * as basicScroll from 'basicscroll';

    let separatorInstances = [];

    const onMount = () => {
        const separators = document.querySelectorAll('.vertical-line');
        const separatorArray = [...separators];

        separatorArray.forEach((separator) => {
            const instance = basicScroll.create({
                elem: separator,
                from: 'bottom-bottom',
                to: 'bottom-middle',
                props: {
                    '--shift': {
                        from: '0px',
                        to: '-180px',
                    }
                },
                direct: true,
            });

            instance.start();
            separatorInstances.push(instance);
        });
    };

    const onDestroy = () => {
        separatorInstances.forEach((instance) => {
            instance.destroy();
        });
        separatorInstances = [];
    }

    export default {
        name: "home",
        components: {
            Carousel, Slide
        },
        mounted: function() {
            this.$nextTick(onMount);
        },
        beforeDestroy: onDestroy,
    };
</script>

<style scoped>
    .VueCarousel-slide {
        position: relative;
        color: #fff;
        font-family: Arial;
        font-size: 24px;
        text-align: center;
        min-height: 100px;
    }

    section {
        display: flex;
        align-items: center;
        position: relative;
    }

    #top {
        height: 100vh;
    }

    #hero, #portfolio, #people, #perspectives {
        padding-top: 200px;
        padding-bottom: 200px;
    }

    .hero--header__large{
        font-size: 20px;
        margin: 20px auto;
        color: white;
        display: block;
        text-align: center;
    }

    .hero--text__normal{
        font-size: 16px;
        margin: 10px auto;
        color: white;
        display: block;
        text-align: center;
    }

    #hero, #portfolio, #people, #perspectives{
        background-color: black;
    }

    #perspectives{
        height: 100%;
    }

    .section--title {
        font-size: 20px;
        text-transform: uppercase;
        text-align: center;
        color: #fff;
    }

    .section--title__large {
        font-size: 60px;
        text-transform: uppercase;
        font-weight: 900;
    }

    .gridCard{
        display: grid;
        grid-template-columns: repeat(auto-fill,minmax(175px,1fr));
        grid-template-rows: 1fr;
        grid-gap: 20px;
        padding: 0 75px;
        justify-items: center;
    }

    #portfolioCardClassic .card {
        width: 175px;
        height: 175px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-transition: -webkit-transform .1s ease;
        transition: -webkit-transform .1s ease;
        transition: transform .1s ease;
        transition: transform .1s ease,-webkit-transform .1s ease;
    }

    .card {
        margin: 0px auto;
        position: relative;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        min-width: 0;
        height: 100%;
        word-wrap: break-word;
        background-clip: border-box;
        background-color:transparent;
    }

    #portfolioCardClassic .card-image {
        max-width: 70%;
        height: auto;
        max-height: 70%;
    }

    #portfolio .exited {
        position: absolute;
        max-width: 100%;
        height: auto;
        max-height: 100%;
    }

    #portfolioCardClassic .card:hover img.exited {
        display: none;
    }

    .profile-container {
        padding: 20px;
    }

    .profile-photo {
        height: 100px;
        width: 100px;
    }
    
    body{
        font-family:Lato,sans-serif;
        font-weight:400;
        font-size:16px;
        line-height:1.7;
        color:#777;
    }
    
    .fade-enter-active,.fade-leave-active{
        -webkit-transition-duration:.1s;
        transition-duration:.1s;
        -webkit-transition-property:opacity;
        transition-property:opacity;
        -webkit-transition-timing-function:ease;
        transition-timing-function:ease
    }
    
    .fade-enter,.fade-leave-active{
        opacity:0
    }

    #header h1{
        color:#fff;
        font-size:600%;
        font-weight:700;
        letter-spacing:.3rem;
        text-shadow:.1rem .1rem .8rem #000;
        padding-bottom:1rem;
        padding-top:160px;
        -webkit-animation-name:moveInLeft;
        animation-name:moveInLeft;
        -webkit-animation-duration:1s;
        animation-duration:1s;
        -webkit-animation-timing-function:ease-out;
        animation-timing-function:ease-out
    }

    #hero {
        position: relative;
    }

    .top-ellipse, .bottom-ellipse {
        position: absolute;
        left: 0;
        background-color: black;
        width: 100%;
        height: 150px;
        border-radius: 50%;
    }

    .top-ellipse {
        top: -75px;
    }

    .bottom-ellipse {
        bottom: -75px;
    }

    @media (max-width:768px){

        /* section {
            height: 100%;
        }

        #top {
            padding-top: 200px;
            padding-bottom: 200px;
        } */

        /* #portfolio {
            border-radius: 10% 10% 0 0;
            padding-top: 200px;
        } */

        #portfolio .gridCard{
            padding:0 0
        }

        /* #perspectives {
            padding-bottom: 200px;
            border-radius: 0 0 10% 10%;
        } */
        
        #header h1{
            font-size:400%
        }
        
        #header h3{
            font-size:1.5rem
        }
    }

    @media (max-width:992px){
        /* #perspectives, #people {
            height: 100%;
        } */
    }
    
    #header h3{
        color:#fff;
        font-size:1.6rem;
        font-weight:400;
        padding-bottom:2rem;
        text-shadow:.1rem .1rem .8rem #000;
        -webkit-animation-name:moveInRight;
        animation-name:moveInRight;
        -webkit-animation-duration:1s;
        animation-duration:1s;
        -webkit-animation-timing-function:ease-out;
        animation-timing-function:ease-out
    }

    @-webkit-keyframes moveInLeft{
        0%{
            opacity:0;
            -webkit-transform:translateX(-100px);
            transform:translateX(-100px)
        }
        80%{
            -webkit-transform:translateX(10px);
            transform:translateX(10px)
        }
        to{
            opacity:1;
            -webkit-transform:translateX(0);
            transform:translateX(0)
        }
    }

    @keyframes moveInLeft{
        0%{
            opacity:0;
            -webkit-transform:translateX(-100px);
            transform:translateX(-100px)
        }
        80%{
            -webkit-transform:translateX(10px);
            transform:translateX(10px)
        }
        to{
            opacity:1;
            -webkit-transform:translateX(0);
            transform:translateX(0)
        }
    }

    @-webkit-keyframes moveInRight{
        0%{
            opacity:0;
            -webkit-transform:translateX(100px);
            transform:translateX(100px)
        }
        80%{
            -webkit-transform:translateX(-10px);
            transform:translateX(-10px)
        }
        to{
            opacity:1;
            -webkit-transform:translateX(0);
            transform:translateX(0)
        }
    }

    @keyframes moveInRight{
        0%{
            opacity:0;
            -webkit-transform:translateX(100px);
            transform:translateX(100px)
        }
        80%{
            -webkit-transform:translateX(-10px);
            transform:translateX(-10px)
        }
        to{
            opacity:1;
            -webkit-transform:translateX(0);
            transform:translateX(0)
        }
    }
    
    #values{
        padding:5rem 0;
        display:-webkit-box;
        display:-ms-flexbox;
        display:flex;
        text-align:center
    }

    #values hr{
        width:20rem;
        height:.05rem;
        margin:2rem auto 2rem
    }
    
    #portfolio .swiper-slide{
        background-position:50%;
        background-size:cover;
        width:300px;
        height:300px
    }
    
    .swiper-pagination-bullet{
        color:#32325d
    }
    
    #portfolio .gridCard{
        display:grid;
        grid-template-columns:repeat(auto-fill,minmax(175px,1fr));
        grid-template-rows:1fr;
        grid-gap:20px;
        padding:0 75px;
        justify-items:center
    }
    
    #portfolio hr{
        width:20rem;
        height:.05rem;
        margin:2rem auto 2rem;
        margin-bottom:3rem
    }

    #contact{
        padding:4.25rem 0
    }
    
    #contact h3{
        padding-bottom:30px
    }
    
    #contact .contact-left,#contact .contact-right{
        background-color:rgba(255,17,0,.21);
        padding:30px;
        border-radius:10px
    }
    
    #contact .or{
        font-size:2rem;
        font-weight:700
    }
    
    #contact hr{
        width:20rem;
        height:.05rem;
        margin:2rem auto 1rem
    }

    .card {
        max-width: 340px;
        width: 100%;
        position: relative;
        padding: 12px;
        z-index: 1;
    }

    .card__image {
        padding: 0 0 12px 0;
    }

    .card__image img {
        min-height: 165px;
        max-width: 100%;
        display: block;
        margin: 0;
        transform: scale(1);
        will-change: transform;
        transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .card:hover .card__image img {
        transform: scale(1.03);
    }

    .card__content {
        padding: 0;
    }

    .card__title span, h1 {
        color: #fff;
        font-weight: bold;
        padding: 0;
        cursor: pointer;
    }

    .vertical-line-container {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        height: 180px;
        overflow: hidden;
        z-index: 2;
        bottom: -90px;
    }
    

    .vertical-line {
        width: 2px;
        height: 100%;
        background-color: #4A4A4A;

        /* use variable created by basicscroll */
        transform: translateY(var(--shift)); transition: transform .1s;

        will-change: transform;
    }

    .subsection--title {
        font-size: 18px;
        text-transform: uppercase;
        text-align: center;
        color: #aaa;
        margin: 4rem 0rem;
    }

</style>
